import IMask from 'imask';
import { telephoneMasks } from './telephone';

const phoneMasked = IMask.createMask({ mask: telephoneMasks });

export const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;

export const isEmail = (data: string) => emailPattern.test(data);
export const isPhoneNumber = (data: string) => {
  phoneMasked.value = data;
  return phoneMasked.unmaskedValue.length >= 10;
};